import React from "react";
import { Input, Button, Space } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";

export const TextSearchFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}: FilterDropdownProps): JSX.Element => {
  const searchValue = selectedKeys[0] as string;

  return (
    <div style={{ padding: 8 }}>
      <Space direction="vertical">
        <Input
          placeholder="Search"
          value={searchValue}
          onChange={(e): void =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={(): void => confirm()}
          style={{ width: "100%" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(): void => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={(): void => {
              clearFilters && clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </Space>
    </div>
  );
};

export const renderTextSearchFilter = (
  props: FilterDropdownProps
): JSX.Element => {
  return <TextSearchFilter {...props} />;
};
